import routes from './routes';

export const creditoFeature = {
  name: 'credito',
  routes,
};
